module.exports = __webpack_public_path__ + "static/primordial-jade-winged-spear-458580af03c93ba15ae6a9e8b6e367f0.png";